var __read = this && this.__read || function (o, n) {
  var m = typeof Symbol === "function" && o[Symbol.iterator];
  if (!m) return o;
  var i = m.call(o),
    r,
    ar = [],
    e;
  try {
    while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
  } catch (error) {
    e = {
      error: error
    };
  } finally {
    try {
      if (r && !r.done && (m = i["return"])) m.call(i);
    } finally {
      if (e) throw e.error;
    }
  }
  return ar;
};
import * as React from 'react';
import { formatText } from 'bernie-l10n';
import { UitkExpandoPeek } from 'uitk-react-expando';
import { UitkUnformattedHtml } from 'uitk-react-unformatted-html';
import { UitkSpacing } from 'uitk-react-spacing';
import { useStores } from '../../../utils/hooks';
export var Description = function (_a) {
  var description = _a.description,
    _b = _a.isContentHierarchyTestEnabled,
    isContentHierarchyTestEnabled = _b === void 0 ? false : _b;
  var analytics = useStores().analytics;
  var _c = __read(React.useState(false), 2),
    viewExpanded = _c[0],
    setViewExpanded = _c[1];
  var dangerouslySetInnerHTMLDescription = description || '';
  var handleToggleClick = function () {
    setViewExpanded(!viewExpanded);
    var rfrrID = viewExpanded ? 'LX.IS.DESC.ShowLess' : 'LX.IS.DESC.ShowMore';
    if (typeof analytics.trackEvent === 'function') {
      analytics.trackEvent(rfrrID, rfrrID, analytics.omnitureData);
    }
  };
  var descriptionContent = React.createElement("div", {
    "data-testid": "description"
  }, React.createElement(UitkUnformattedHtml, {
    htmlToParse: dangerouslySetInnerHTMLDescription
  }));
  return React.createElement(UitkSpacing, {
    padding: isContentHierarchyTestEnabled ? undefined : {
      inline: 'three',
      block: 'three'
    },
    margin: isContentHierarchyTestEnabled ? {
      blockstart: 'three'
    } : undefined
  }, React.createElement("section", {
    "data-testid": "activity-description",
    "aria-hidden": "false"
  }, React.createElement(UitkExpandoPeek, {
    lines: 4,
    isVisible: viewExpanded,
    expandLabel: formatText('lx.activity.seeMore'),
    collapseLabel: formatText('lx.activity.seeLess'),
    handleClick: handleToggleClick,
    "aria-required": "true"
  }, descriptionContent)));
};